import React, { useEffect, useState } from "react";
import { RiSearch2Fill } from "react-icons/ri";
import Form from "react-bootstrap/Form";
import { GoArrowRight } from "react-icons/go";
import { IoFilter } from "react-icons/io5";
import { FaLongArrowAltLeft } from "react-icons/fa";
import dummyComapyLogo from "../../../assets/dummyComapyLogo.png";
import { FaAngleLeft, FaAngleRight, FaLocationDot } from "react-icons/fa6";
import { PaginationBtn } from "../../component/ReUseComps/Button";
import { MdOutlineKeyboardBackspace } from "react-icons/md";
import cashMultiple from "../../../assets/cash-multiple.png";
import bagSolid from "../../../assets/bag-solid.png";
import { useNavigate } from "react-router-dom";
import { URLS } from "../../../Utils/App_urls";
import { Oval } from "react-loader-spinner";
import axios from "axios";
import "../../Pages/ApplyJob/FilterJob/FilterJob.css";
import "./NotInterested.css";
import { IoSearch } from "react-icons/io5";
import BackArrowIcon from "../../../assets/filter-back-arrow.png";

export default function NotInterested({ isFilterShow, handleSetFilter }) {
  const [showArrow, setShowArrow] = useState(false);
  const [allJobAfterFilter, setAllAfterFilter] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const navigate = useNavigate();
  const [paginationBtnArr, setpaginationBtnArr] = useState([1, 2, 3, 4, 5]);
  const [clipArrLength, setClipArrLength] = useState({ min: 0, max: 10 });
  const isLoggedIn = !!localStorage.getItem("userToken");
  const [loading, setLoading] = useState(false);

  // Consolidated filter state
  const [filters, setFilters] = useState({
    sortBy: "all",
    experience: "",
    workPlace: "",
    shift: "",
    deparmentType: "",
    title: "",
    skills: "",
    jobLocations: "",
  });

  const handleFilterChange = (type, value) => {
    setFilters((prev) => ({
      ...prev,
      [type]: value,
    }));
  };

  const getAllJobs = () => {
    setLoading(true);
    const params = {};

    Object.keys(filters).forEach((key) => {
      if (filters[key] && filters[key] !== "") {
        params[key] = filters[key];
      }
    });
    params.page = 1;
    params.limit = 10;

    axios
      .get(`${URLS.getNotInterestedJob}`, {
        params,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("userToken")}`,
        },
      })
      .then((res) => {
        console.log("not interested response", res.data.result);
        setAllAfterFilter(res?.data?.result || []);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  };

  const handleResetFilter = () => {
    setFilters({
      sortBy: "all",
      experience: "",
      workPlace: "",
      shift: "",
      deparmentType: "",
      title: "",
      skills: "",
      jobLocations: "",
    });
    // Fetch jobs without filters after a small delay to allow state to update
    setTimeout(() => {
      getAllJobs();
    }, 100);
  };

  const handleSubmitForm = (e) => {
    e.preventDefault();
    getAllJobs();
  };

  const redirectTojobDetails = (id) => {
    navigate(`/user/notIntested-jobs/job-details/${id}`, {
      state: { DATA: id },
    });
  };

  const handlePaginationSize = (pgNo) => {
    let max = pgNo * 10;
    let min = max - 10 >= 0 ? max - 10 : 0;
    setClipArrLength({ min: min, max: max });
  };

  const handleIncPagination = () => {
    setpaginationBtnArr(paginationBtnArr.map((item) => item + 1));
    setClipArrLength({
      min: paginationBtnArr[paginationBtnArr.length - 1] * 10 - 10,
      max: paginationBtnArr[paginationBtnArr.length - 1] * 10,
    });
  };

  const handleDecPagination = () => {
    if (paginationBtnArr[0] > 1) {
      setpaginationBtnArr(paginationBtnArr.map((item) => item - 1));
    }
    paginationBtnArr[0] >= 0 &&
      setClipArrLength({
        min: paginationBtnArr[0] * 10 - 10,
        max: paginationBtnArr[0] * 10,
      });
  };

  const postedDate = (data) => {
    const firstDate = new Date(data);
    const currentDate = new Date();
    const timeDifference = currentDate - firstDate;
    const daysDifference = Math.floor(timeDifference / (1000 * 3600 * 24));
    return daysDifference > 0
      ? `${daysDifference} Day${daysDifference > 1 ? "s" : ""} ago`
      : "Posted Today";
  };

  useEffect(() => {
    getAllJobs();
  }, []);

  useEffect(() => {
    getAllJobs();
  }, [filters]);

  return (
    <div className="not_interseted_main">
      <div className="container-archive d-flex gap-3">
        <span
          style={{
            fontSize: "20px",
            color: "#3284ff",
          }}
        >
          <IoFilter
            className="show-filter-btn"
            onClick={() => setShowFilter(!showFilter)}
          />
        </span>
        <div
          className={`search-Filter-Container ${
            showFilter ? "filter-visible" : "filter-hidden"
          }`}
        >
          <div className="filter-job-main d-flex flex-column gap-3">
            <div className="filter-header d-flex align-items-center justify-content-between">
              <h1
                className={isFilterShow ? "filter-head" : "filter-head-black"}
              >
                {showFilter && (
                  <FaLongArrowAltLeft
                    style={{
                      color: "#3284ff",
                    }}
                    className="arrow-Filter"
                    onClick={() => setShowFilter(!showFilter)}
                  />
                )}
                Filter
              </h1>
              <p onClick={handleResetFilter}>Reset</p>
            </div>
            <div className="cross-line-dividor" />

            {isLoggedIn && (
              <>
                <div className="job-search-header d-flex gap-1 mb-3 p-0">
                  <Form
                    onSubmit={handleSubmitForm}
                    className="d-flex gap-1 justify-content-sm-between justify-content-center flex-wrap"
                  >
                    <div className="serch-job-input d-flex align-items-center justify-content-between">
                      <IoSearch fontSize={20} />
                      <Form.Control
                        placeholder="Job Title"
                        aria-label="Job Title"
                        value={filters.title}
                        onChange={(e) =>
                          handleFilterChange("title", e.target.value)
                        }
                      />
                    </div>
                  </Form>
                </div>
                <div className="cross-line-dividor" />
              </>
            )}

            <div className="sort-container">
              <p>Sort By</p>
              {["all", "recent", "lastWeek", "lastMonth"].map((time) => (
                <span key={time}>
                  <input
                    type="radio"
                    name="sort-by-time"
                    id={time}
                    value={time}
                    checked={filters.sortBy === time}
                    onChange={(e) => handleFilterChange("sortBy", time)}
                  />
                  <label htmlFor={time}>
                    {time === "recent"
                      ? "Today"
                      : time === "lastWeek"
                      ? "Last week"
                      : time === "lastMonth"
                      ? "Last 30 Days"
                      : "All"}
                  </label>
                </span>
              ))}
            </div>
            <div className="cross-line-dividor" />
            <div className="work-experience-menu d-flex flex-column gap-2">
              <h1>Work Experience</h1>
              <Form.Select
                value={filters.experience || ""}
                onChange={(e) =>
                  handleFilterChange("experience", e.target.value)
                }
              >
                <option value={""} disabled>
                  Select Experience
                </option>
                <option value="Fresher">Fresher</option>
                <option value="1-2 years">1-2 years</option>
                <option value="2-3 years">2-3 years</option>
                <option value="3-5 years">3-5 years</option>
                <option value="5+ years">5 + years</option>
              </Form.Select>
            </div>
            <div className="cross-line-dividor" />
            <div className="sort-container">
              <p>Preferred Workplace</p>
              {["On-site", "Off-site", "Hybrid"].map((place) => (
                <span key={place}>
                  <input
                    type="radio"
                    name="preferred-workplace"
                    id={place}
                    value={place}
                    checked={filters.workPlace === place}
                    onChange={(e) => handleFilterChange("workPlace", place)}
                  />
                  <label htmlFor={place}>
                    {place === "Off-site" ? "Work From Home" : place}
                  </label>
                </span>
              ))}
            </div>
            <div className="cross-line-dividor" />
            <div className="sort-container">
              <p>Preferred Shift</p>
              {["Day Shift", "Night Shift"].map((shift) => (
                <span key={shift}>
                  <input
                    type="radio"
                    name="Preferred-Shift"
                    id={shift}
                    value={shift}
                    checked={filters.shift === shift}
                    onChange={(e) => handleFilterChange("shift", shift)}
                  />
                  <label htmlFor={shift}>{shift}</label>
                </span>
              ))}
            </div>
            <div className="cross-line-dividor" />
            <div className="sort-container">
              <p>Employenment Type</p>
              {["Full Time", "Part Time", "contract"].map((type) => (
                <span key={type}>
                  <input
                    type="radio"
                    name="Employenment-Type"
                    id={type}
                    value={type}
                    checked={filters.deparmentType === type}
                    onChange={(e) => handleFilterChange("deparmentType", type)}
                  />
                  <label htmlFor={type}>{type}</label>
                </span>
              ))}
            </div>
            <div className="cross-line-dividor" />
            <div className="sort-container">
              <p>Skills</p>
              <span className="location-input">
                <input
                  className="input-skills"
                  value={filters.skills}
                  onChange={(e) => handleFilterChange("skills", e.target.value)}
                  type="text"
                  name="skill"
                  placeholder="search by skills"
                />
              </span>
            </div>
            <div className="cross-line-dividor" />
            <div className="sort-container">
              <p>Location</p>
              <span className="location-input">
                <input
                  className="input-locations"
                  value={filters.jobLocations}
                  onChange={(e) =>
                    handleFilterChange("jobLocations", e.target.value)
                  }
                  type="text"
                  name="location"
                  placeholder="search by location"
                />
              </span>
            </div>
          </div>
        </div>

        <div className="archive_parents">
          <h1
            className="d-flex align-items-center gap-1 heading-achive"
            onClick={() => navigate(-1)}
          >
            <MdOutlineKeyboardBackspace fontSize={26} />
            Archives Job Details
          </h1>

          {loading ? (
            <div className="d-flex justify-content-center mt-5">
              <Oval width="50" height="50px" color="#3284FF" />
            </div>
          ) : allJobAfterFilter?.length > 0 ? (
            <>
              {allJobAfterFilter.map(
                (job, index) =>
                  index >= clipArrLength.min &&
                  index < clipArrLength.max && (
                    <div className="job-search-body mb-3" key={index}>
                      <div className="job-cards d-flex ">
                        <div className="job-right-container d-flex flex-column gap-2 flex-grow-1">
                          <div className="job-card-header d-flex align-items-start justify-content-between flex-wrap gap-2">
                            <div className="company-title d-flex align-items-start gap-3 mb-2">
                              <div>
                                <img
                                  src={job?.companylogo || dummyComapyLogo}
                                  alt={job?.company}
                                />
                              </div>
                              <div className="compay-name">
                                <h1 className="m-0">{job?.title}</h1>
                                <p className="m-0">
                                  {job?.companyName || "ABC pvt. Ltd."}
                                </p>
                              </div>
                            </div>
                            <p className="m-0 d-flex flex-column">
                              <span>
                                {postedDate(job?.createdAt?.split("T")[0])}
                              </span>
                            </p>
                          </div>
                          <div className="job-conadtion-box">
                            <div>
                              <img src={bagSolid} alt="bag solid" />{" "}
                              <span>{job?.experience}</span>
                            </div>
                            {job?.salaryType === "Fixed Salary" && (
                              <div>
                                <img src={cashMultiple} alt="cash multiple" />{" "}
                                <span>{job?.FixedSalary}LPA</span>
                              </div>
                            )}
                            {job?.salaryType === "Salary Range" && (
                              <div>
                                <img src={cashMultiple} alt="cash multiple" />{" "}
                                <span>
                                  {job?.minSalary} - {job?.maxSalary}LPA
                                </span>
                              </div>
                            )}
                            {job?.salaryType === "Not Disclose" && (
                              <div>
                                <img src={cashMultiple} alt="cash multiple" />{" "}
                                <span>{job?.salaryType}</span>
                              </div>
                            )}
                            <div>
                              <FaLocationDot /> <span>{job?.workPlace}</span>
                            </div>
                          </div>

                          <div className="job-preferences d-flex gap-1 gap-sm-3 flex-wrap">
                            <span>{job?.deparmentType}</span>
                            <span>{job?.workPlace}</span>
                            <span>{job?.shift}</span>
                          </div>

                          <div>
                            {job?.jobSummary?.slice(0, 400)}
                            {job?.jobSummary?.length > 400 && "..."}
                          </div>
                          <div className="company-req-skills d-flex flex-wrap gap-2 gap-sm-3">
                            {job?.skills?.map((skill, index) => (
                              <span key={index}>{skill}</span>
                            ))}
                          </div>
                        </div>
                        <div className="cards-btn-box flex-row flex-sm-column flex-wrap">
                          <button
                            className="job-search-btn"
                            onClick={() => redirectTojobDetails(job?._id)}
                          >
                            View <GoArrowRight fontSize={20} />
                          </button>
                        </div>
                      </div>
                    </div>
                  )
              )}

              {/* Pagination controls */}
              {/* <div className="d-flex justify-content-center gap-2 mt-4">
                <PaginationBtn onClick={handleDecPagination}>
                  <FaAngleLeft />
                </PaginationBtn>
                {paginationBtnArr.map((btn) => (
                  <PaginationBtn
                    key={btn}
                    onClick={() => handlePaginationSize(btn)}
                    active={btn === clipArrLength.max / 10}
                  >
                    {btn}
                  </PaginationBtn>
                ))}
                <PaginationBtn onClick={handleIncPagination}>
                  <FaAngleRight />
                </PaginationBtn>
              </div> */}
            </>
          ) : (
            <h1 className="warning-none d-flex flex-column align-items-center">
              No Job Found
            </h1>
          )}
        </div>
      </div>
    </div>
  );
}
